import React from 'react'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import '../../css/aboutus.css'
import Aos from 'aos'

const Parikalpana = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right' data-aos='fade-right'>
                        <div className='aboutus-body-1'>
                            <div className='aboutus-body-title'>
                                <h1>हाम्रो परिकल्पना</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>“ समुदायमा आधारित, उत्कृष्ट, प्रतिश्पर्धी एवम् दिगो वित्तीय सहकारी संस्था ”</p>
                            </div>
                        </div>

                        <div className='aboutus-body-2'>
                            <div className='aboutus-body-title'>
                                <h1>Our Vision</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>" Community Based, Excellent, competitive and Sustainable Financial Co- operative society " </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Parikalpana